import type { FC } from "react";

export const Paragraph: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <p className={"text-sm text-gray-700 mb-4"}>{children}</p>;
};
